module.exports = __webpack_public_path__ + "img/product-placeholder-73.e95479c.png";